import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import Post from "./Post";
import Edit from "./Edit";
import {RouterProps} from "../../../RouterProps";

export default function RewardRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:contentUserProductionRewardId'} element={<Detail {...props} />} />
            <Route path={'/:contentUserProductionRewardId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}